import {Button as MuiButton} from '@mui/material';
import PropTypes from 'prop-types';
import React, {Component} from 'react';
import {connect} from 'react-redux';

import FontAwesome from '@cdo/apps/legacySharedComponents/FontAwesome';
import PopUpMenu, {MenuBreak} from '@cdo/apps/sharedComponents/PopUpMenu';
import color from '@cdo/apps/util/color';
import i18n from '@cdo/locale';

import QuickActionsCell from '../tables/QuickActionsCell';

import {showDeleteDialog} from './deleteDialog/deleteProjectDialogRedux';
import ProjectNameFailureDialog from './ProjectNameFailureDialog';
import {
  startRenamingProject,
  cancelRenamingProject,
  saveProjectName,
  unsetNameFailure,
} from './projectsRedux';

import moduleStyles from './personal-projects-table-actions-cell.module.scss';

export class PersonalProjectsTableActionsCell extends Component {
  static propTypes = {
    projectId: PropTypes.string.isRequired,
    projectType: PropTypes.string.isRequired,
    showDeleteDialog: PropTypes.func.isRequired,
    isEditing: PropTypes.bool,
    isSaving: PropTypes.bool,
    startRenamingProject: PropTypes.func.isRequired,
    updatedName: PropTypes.string,
    cancelRenamingProject: PropTypes.func.isRequired,
    saveProjectName: PropTypes.func.isRequired,
    projectNameFailure: PropTypes.string,
    unsetNameFailure: PropTypes.func.isRequired,
    isFrozen: PropTypes.bool,
  };

  onDelete = () => {
    this.props.showDeleteDialog(this.props.projectId);
  };

  onRename = () => {
    this.props.startRenamingProject(this.props.projectId);
  };

  onCancel = () => {
    this.props.cancelRenamingProject(this.props.projectId);
  };

  onSave = () => {
    this.props.saveProjectName(this.props.projectId, this.props.updatedName);
  };

  onRemix = () => {
    window.location = `/projects/${this.props.projectType}/${this.props.projectId}/remix`;
  };

  handleNameFailureDialogClose = () => {
    this.props.unsetNameFailure(this.props.projectId);
  };

  render() {
    const {isEditing, isSaving} = this.props;

    return (
      <div>
        {!isEditing && (
          <QuickActionsCell>
            {!this.props.isFrozen && (
              <PopUpMenu.Item onClick={this.onRename}>
                {i18n.rename()}
              </PopUpMenu.Item>
            )}
            <PopUpMenu.Item onClick={this.onRemix}>
              {i18n.remix()}
            </PopUpMenu.Item>
            {!this.props.isFrozen && <MenuBreak />}
            {!this.props.isFrozen && (
              <PopUpMenu.Item onClick={this.onDelete} color={color.red}>
                <FontAwesome
                  icon="circle-xmark"
                  className={moduleStyles.xIcon}
                />
                {i18n.delete()}
              </PopUpMenu.Item>
            )}
          </QuickActionsCell>
        )}
        {isEditing && (
          <div>
            <MuiButton
              variant="contained"
              color="primary"
              size="small"
              disabled={isSaving}
              className={moduleStyles.buttonMargin}
              id="ui-projects-rename-save"
              onClick={this.onSave}
              type="button"
            >
              {i18n.save()}
            </MuiButton>
            <MuiButton
              variant="outlined"
              color="tertiary"
              size="small"
              onClick={this.onCancel}
              type="button"
            >
              {i18n.cancel()}
            </MuiButton>
          </div>
        )}
        <ProjectNameFailureDialog
          flaggedText={this.props.projectNameFailure}
          isOpen={!!this.props.projectNameFailure}
          handleClose={this.handleNameFailureDialogClose}
        />
      </div>
    );
  }
}

export default connect(
  state => ({}),
  dispatch => ({
    showDeleteDialog(projectId) {
      dispatch(showDeleteDialog(projectId));
    },
    startRenamingProject(projectId, updatedName) {
      dispatch(startRenamingProject(projectId, updatedName));
    },
    cancelRenamingProject(projectId) {
      dispatch(cancelRenamingProject(projectId));
    },
    saveProjectName(projectId, updatedName, lastUpdatedAt) {
      dispatch(saveProjectName(projectId, updatedName, lastUpdatedAt));
    },
    unsetNameFailure(projectId) {
      dispatch(unsetNameFailure(projectId));
    },
  })
)(PersonalProjectsTableActionsCell);
